import React from 'react';
export default function RouteLoadError({ error, onRetry }) {
  if (!error) return null;
  return <div role="alert" className="m-4 border-2 border-black bg-white p-5 font-mono">
    <p className="text-[11px] font-bold tracking-[.1em] text-[#EF4444]">COULDN'T LOAD THIS PAGE.</p>
    <p className="mt-2 text-sm">Check your connection and try again.</p>
    <button type="button" className="mt-3 border-2 border-black px-4 py-2 text-xs font-bold hover:bg-black hover:text-white" onClick={onRetry}>RETRY</button>
  </div>;
}
